import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import WebFont from 'webfontloader';
import App from './App';
import './icons';
import 'normalize.css/normalize.css';
import './styles/global.scss';

const DATA_ATTR = 'data-bluesky-ui-version';

let root;

const component = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// load OTC fonts
WebFont.load({
  google: {
    families: [
      'Nunito Sans:200,200i,400,400i,600,600i,700,700i,800,800i900,900i',
      'Source Serif Pro:400,700'
    ]
  }
});

const version = process.env.REACT_APP_VERSION;

if (window.location.port === '3004') {
  const rootElement = document.getElementById('root');
  rootElement.setAttribute(DATA_ATTR, version);

  root = createRoot(rootElement);
  root.render(component);

}

window.renderBlueSkyApp = (containerId) => {
  const rootElement = document.getElementById(containerId);
  if (!rootElement) return;
  
  rootElement.setAttribute(DATA_ATTR, version);
  root = createRoot(rootElement);
  root.render(component);
};

window.unmountBlueSkyApp = () => {
  root.unmount();
};
